import axios from "axios";

export function getVideos(s: string = '', page: number = 1, per_page: number = 12, club_id: number = 0, user_id: number = 0) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (club_id > 0) {
        params.push('club_id=' + club_id);
    }
    if (user_id > 0) {
        params.push('user_id=' + user_id);
    }
    params.push('page=' + page);
    params.push('per_page=' + per_page);
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getVideoOptions(s: string = '', page: number = 1, per_page: number = 12) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video/options';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    params.push('page=' + page);
    params.push('per_page=' + per_page);
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getVideoSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createVideo(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateVideo(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteVideo(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/video/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}